import * as React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import "./autocomplete.scss";
import {autoCompleteItem} from "../../modals/types/autocomplete";

interface IAutoComplete {
    items: autoCompleteItem[]
    title: string
}

export default function AutoComplete({items, title}: IAutoComplete) {
    return (
        <div className="Auto-Complete">
            <Stack spacing={3}>
                <Autocomplete
                    multiple
                    className={"border-5"}
                    id="tags-outlined"
                    options={items}
                    getOptionLabel={(option) => option.title}
                    // defaultValue={[suggestion[0]]}
                    filterSelectedOptions
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={title}
                            placeholder="انتخاب کنید"
                        />
                    )}
                />
            </Stack>
        </div>
    );
}
